import { ThresholdLevelSelection } from './threshold-level-selection.model';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class Recipient {
  selectedThresholds: ThresholdLevelSelection;
  value: string;
}
